import { render, staticRenderFns } from "./RoomInformation.vue?vue&type=template&id=a6a4d2f0&scoped=true"
import script from "./RoomInformation.vue?vue&type=script&lang=js"
export * from "./RoomInformation.vue?vue&type=script&lang=js"
import style0 from "./RoomInformation.vue?vue&type=style&index=0&id=a6a4d2f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a4d2f0",
  null
  
)

export default component.exports